import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTransaction, useWatchContractEvent } from "wagmi";
import { parseAbiItem } from "viem";

const brainCreditsABI = parseAbiItem(
  "event Transfer(address indexed from, address indexed to, uint256 value)"
);

export default function BurnSuccess({ coinsBurned, hash }) {
  const { data: transaction, isLoading: isTransactionLoading } = useTransaction(
    {
      hash: hash,
    }
  );

  return (
    <div className="thank-you text-center">
      <svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.96777 10.4862L7.18718 14.6617C8.41167 15.6413 10.1876 15.4961 11.2367 14.3305L22.689 1.60571"
          stroke="url(#paint0_linear_290_688)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_290_688"
            x1="12.3284"
            y1="1.60571"
            x2="12.3284"
            y2="15.3105"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#75FBFD" />
            <stop offset="1" stopColor="#75FBFD" stopOpacity="0.44" />
          </linearGradient>
        </defs>
      </svg>
      <small className="font-mono text-uppercase d-block my-4">
        YOU SUCCESSFULLY BURNED <span className="text-blue">{coinsBurned}</span>{" "}
        PEPECOIN.
        <br />
        <br />
        <Link
          style={{ color: "#e2e2e2" }}
          to={`https://etherscan.io/tx/${hash}`}
        >
          VIEW ON ETHERSCAN
        </Link>
      </small>
      <div className="d-flex flex-column align-items-center">
        <Link
          to="/burning-redeem"
          className="button align-items-center d-flex justify-content-center"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12.3574" cy="12.0234" r="12" fill="black" />
            <path
              d="M12.3574 8.78125L14.9508 12.023L12.3574 15.2647"
              stroke="#75FBFD"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {/* TODO: Change to stake */}
          <span className="ps-3">REDEEM MY BRAIN CREDITS</span>
          {/* <span className="ps-3">VIEW MY INVENTORY</span> */}
        </Link>
      </div>
    </div>
  );
}
